<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Galería del pedido</h3>
      </div>
    </div>
    <div class="row">
      <div v-if="form.path_cliente != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Cliente</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_cliente" target="_blank">
                <img
                  :src="urlStorage + form.path_cliente"
                  alt="Cliente"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_firma_cliente != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Firma de cliente</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_firma_cliente" target="_blank">
                <img
                  :src="urlStorage + form.path_firma_cliente"
                  alt="Firma de cliente"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_contrato != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Contrato</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_contrato" target="_blank">
                <img
                  :src="urlStorage + form.path_contrato"
                  alt="Contrato"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_croquis != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Croquis</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_croquis" target="_blank">
                <img
                  :src="urlStorage + form.path_croquis"
                  alt="Croquis"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_dibujo_croquis != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Dibujo de croquis</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_dibujo_croquis" target="_blank">
                <img
                  :src="urlStorage + form.path_dibujo_croquis"
                  alt="Dibujo de croquis"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_adicional != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Adicional</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_adicional" target="_blank">
                <img
                  :src="urlStorage + form.path_adicional"
                  alt="Adicional"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_adicional2 != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Documento</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_adicional2" target="_blank">
                <img
                  :src="urlStorage + form.path_adicional2"
                  alt="Documento"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
      <div v-if="form.path_adicional3 != null" class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Casa</h5>
          </div>
          <div class="card__content">
            <center>
              <a :href="urlStorage + form.path_adicional3" target="_blank">
                <img
                  :src="urlStorage + form.path_adicional3"
                  alt="Casa"
                  width="250px"
                  height="200px"
                />
              </a>
            </center>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      form: this.value,
      urlStorage: url + "/storage/",
    };
  },
  methods: {
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/GaleriaPedidos.vue